import { AppProvider } from "./app.provider"

export class BaseProvider {
  protected Providers!: AppProvider

  setProviders = (providers: AppProvider) => {
    this.Providers = providers
  }
}
